/**
 * Entry point for all public APIs of the package.
 */
export { PersistenceService, AbstractCachedService, StorageType, PersistenceModule } from './src/angular-persistence';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-persistence/index.js
// module id = 327
// module chunks = 3